import BaseContent from "../base.content";
import { List } from 'immutable';
import {CMSContentType} from "../CMSType";
import {BaseListContentParams, BaseListContent} from "../content/list.abstract.content";


export interface HeaderBaseContentParams<T> extends BaseListContentParams<T> {
  label: string;
}

export abstract class HeaderBaseContent<ChildType extends BaseContent>  extends BaseListContent<ChildType> {
  readonly label: string;

  constructor(type: CMSContentType, data: HeaderBaseContentParams<ChildType>) {
    super(type, data);
    this.label = data.label;
  }

  get children(): List<ChildType>{
      return this.items;
  }

  setLabel(label: string): this {
    return this._merge({label})
  }

  public toJSON() {
    return {
      label: this.label,
      type: this.type,
      items: this.items.toArray(),
      children: this.children
        .map((child) => child.toJSON())
        .toArray()
    }
  }

}

export default HeaderBaseContent;



// WEBPACK FOOTER //
// ./src/api/club-cms/headers/base.header.ts